import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const OurWork = ( props ) => {
  const { classes } = props;

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>Our work</h3>
              <p className={classes.aboutUsText}>
                Our diverse evidence to policy portfolio spans all major development sectors and regions and represents the scale and depth of 3ie&apos;s global programs and initiatives.
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}our-work`}
              >
                Explore Our work
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <ul className={classes.aboutUsListGrid}>
                <li><a href={`${SITE_LINK}our-work/education`} rel="noopener noreferrer">Education</a></li>
                <li><a href={`${SITE_LINK}our-work/peacebuilding`} rel="noopener noreferrer">Peacebuilding</a></li>
                <li><a href={`${SITE_LINK}our-work/food-systems-and-nutrition-evidence-and-gap-map`} rel="noopener noreferrer">Food Systems and Nutrition Evidence and Gap map</a></li>
                <li><a href={`${SITE_LINK}our-work/gender-and-womens-empowerment`} rel="noopener noreferrer">Gender and women’s empowerment</a></li>
                <li><a href={`${SITE_LINK}our-work/mitigating-and-adapting-climate-change`} rel="noopener noreferrer">Mitigating and adapting to climate change</a></li>
                <li><a href={`${SITE_LINK}our-work/innovations-data-impact-evaluation`} rel="noopener noreferrer">Innovations in data for impact evaluation</a></li>
                <li><a href={`${SITE_LINK}our-work/research-commissioning-centre-rcc`} rel="noopener noreferrer">Research Commissioning Centre</a></li>
                <li><a href={`${SITE_LINK}our-work/west-africa-capacity-building-and-impact-evaluation`} rel="noopener noreferrer">WACIE</a></li>
                <li><a href={`${SITE_LINK}our-work/rural-india-livelihoods-project`} rel="noopener noreferrer">Rural India Livelihoods Project</a></li>
                <li><a href={`${SITE_LINK}our-work/global-evidence-commitment-advancing-use-rigorous-evidence`} rel="noopener noreferrer">Global Evidence Commitment: Advancing Use of Rigorous Evidence</a></li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

OurWork.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles( styles )( OurWork );
